export default __webpack_public_path__ + "static/media/recommendation_sim.ae7f2467.svg";